// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3804":"css/admin-app.6916","5310":"css/app.6916"}[chunkId] + ".css";
};